import { render } from "./EditComponentBlock.vue?vue&type=template&id=a822800c&scoped=true"
import script from "./EditComponentBlock.vue?vue&type=script&lang=js"
export * from "./EditComponentBlock.vue?vue&type=script&lang=js"

import "./EditComponentBlock.vue?vue&type=style&index=0&id=a822800c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a822800c"

export default script